import { useQuery } from 'react-query';
import { getRestrictions } from '../services/restrictionsService';

const datasetDescriptions = {
  'conservation-area':
    'Areas designated to preserve historical or architectural interest. Development is restricted to maintain character.',
  'contaminated-land':
    'Land affected by hazardous substances. Development requires remediation, impacting feasibility and costs.',
  'brownfield-land':
    'Previously developed land now vacant or underused. Often prioritized for redevelopment.',
  'brownfield-site':
    'Similar to Brownfield Land; previously developed sites available for reuse and redevelopment.',
  'green-belt-core': 'Areas designated to prevent urban sprawl. Development is highly restricted.',
  'local-green-space':
    'Green areas of importance to communities. Development is limited to protect these spaces.',
  'tree-preservation-zone':
    'Areas where trees are legally protected. Development requires special permissions.',
  'ancient-woodland':
    'Woodlands existing since at least 1600 AD. Development is heavily restricted to preserve ecological value.',
  'flood-risk-zone':
    'Areas prone to flooding. Development requires stringent assessments and mitigation.',
  'green-belt': 'Land designated to limit urban sprawl. Development is generally restricted.',
  'agricultural-land-classification':
    'Grades land based on agricultural quality. High-grade land has development restrictions.',
  'area-of-outstanding-natural-beauty':
    'Conservation areas with significant landscape value. Development is highly controlled.',
  'building-preservation-notice':
    'Notices protecting unlisted buildings of historical interest. Development is restricted pending further assessment.',
  'built-up-area': 'Areas characterized by dense development. Planning may favor redevelopment.',
  'design-code-area':
    'Areas with specific design guidelines. Development must adhere to these standards.',
  'heritage-coast':
    'Coastal areas managed to conserve natural beauty. Development is highly restricted.',
  'listed-building':
    'Buildings designated as of special architectural or historic interest. Alterations require special permissions.',
  'local-nature-reserve':
    'Areas designated for wildlife conservation. Development is limited to protect habitats.',
  'national-park': 'Protected areas of national significance. Development is strictly controlled.',
  'site-of-special-scientific-interest':
    'Areas protected for their wildlife or geological value. Development is highly restricted.',
  'special-area-of-conservation':
    'Protected sites under the EU Habitats Directive. Development is heavily controlled.',
  'special-protection-area':
    'Protected areas for vulnerable bird species. Development is highly restricted.',
};

const useRestrictions = (location) => {
  return useQuery({
    queryKey: ['restrictions', location?.postcode, location?.lat, location?.lng],
    queryFn: async () => {
      const { postcode, lat, lng } = location;
      const response = await getRestrictions(postcode, lat, lng);

      if (response && response.restrictions) {
        return response.restrictions
          .filter((item) => item.entities && item.entities.length > 0)
          .map((item) => ({
            dataset: item.dataset,
            entities: item.entities,
            description: datasetDescriptions[item.dataset] || null,
          }));
      }
      return [];
    },
    enabled: !!(location && location.postcode && location.lat && location.lng),
  });
};

export default useRestrictions;